import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { ProductService } from '../../../service/product.service';

@Component({
  selector: 'app-add-product',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './add-product.html',
  styleUrls: ['./add-product.scss']
})
export class AddProduct {

  private fb = inject(FormBuilder);
  private productService = inject(ProductService);

  loading = signal(false);
  success = signal(false);
  error = signal<string | null>(null);

  form = this.fb.group({
    codigo: [null, Validators.required],
    fkSeccion: [null, Validators.required],
    fkDivision: [null, Validators.required],
    fkClase: [null, Validators.required],
    codigoINE: ['', Validators.required],
    nombre: ['', Validators.required],

    ponderacion: [0],
    ponderacionImportado: [0],
    ponderacionGeneral: [0],

    canasta: ['A'],

    codigoCIIU: [''],
    codigoNAEG: [''],
    codigoNPG: [''],
    codigoCCP: [''],

    referencia: [''],
    estado: ['A']
  });

  onSubmit(): void {
    if (this.form.invalid) return;

    this.loading.set(true);
    this.error.set(null);
    this.success.set(false);

    const payload = {
      ...this.form.value,
      segFuncion: 'ADD',
      segUsuario: 1,
      segTransaccion: 7001, 
      segDatosAnteriores: ''
    };

    this.productService.add(payload as any).subscribe({
      next: () => {
        this.success.set(true);
        this.loading.set(false);
        this.form.reset();
      },
      error: (err) => {
        console.error('Error al guardar el producto:', err);
        this.error.set('Error al guardar el producto.');
        this.loading.set(false);
      }
    });
  }
}
